import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import ListingLayout from 'shared/components/listing-layout'
import ProgressBarFilled from 'shared/components/progress-bar-filled'
import { Table } from 'shared/components/table/table'
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface'
import { withErrorBoundary } from 'shared/hocs/with-error-boundary'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { usePagination } from 'shared/route-query/hooks/use-pagination'
import { ContactId } from '../../types/contact-interface'
import { useContactCourses } from '../hooks/use-contact-courses'
import { ContactCoursesInterface } from '../types/contact-courses-interface'

interface ContactCoursesProps {
  contactId: ContactId
}

const ContactCourses = ({ contactId }: ContactCoursesProps) => {
  const { t } = useLocoTranslation()
  const { limit, pagination, setLimit, setPagination } = usePagination(true)
  const { contactCourses } = useContactCourses({ contactId, limit, pagination })

  const columns: ColumnDefinitionInterface<ContactCoursesInterface>[] = [
    {
      key: 'course' as keyof ContactCoursesInterface,
      widthPercent: 50,
      header: t('dashboard.contact_page.courses.headers.name'),
      onRender: ({ course }) => (
        <LinkWithoutPrefetch
          className="primary-link w-full whitespace-normal"
          href={`/courses/${course.id}/curriculum`}
        >
          {course.name}
        </LinkWithoutPrefetch>
      ),
    },
    {
      key: 'progress',
      widthPercent: 50,
      header: t('dashboard.contact_page.courses.headers.progress'),
      onRender: course => <ProgressBarFilled progress={course.progress} />,
    },
  ]

  return (
    <ListingLayout
      counter={false}
      data={contactCourses}
      title={
        <h2 className={'h-[42px] text-[17px] font-bold'}>{t('dashboard.courses.title_plural')}</h2>
      }
      type={'compact'}
    >
      <Table
        columns={columns}
        data={contactCourses}
        paginator={{ pagination, setPagination }}
        limiter={{ limit, setLimit }}
        isSortable={false}
        nestedId={'course'}
      />
    </ListingLayout>
  )
}

export default withErrorBoundary(ContactCourses)
